export default __webpack_public_path__ + "static/media/main-management.9988adda.jpg";